/* Keep native variant selection and the slideshow's existing PhotoSwipe viewer. */
class FtBundleDefault extends HTMLElement {
  async connectedCallback() {
    if (this.dataset.started) return;
    this.dataset.started = 'true';
    await customElements.whenDefined('variant-picker');
    if (!this.isConnected) return;
    const picker = [...this.parentElement.querySelectorAll('variant-picker')].find(p => p.getAttribute('form-id') === this.getAttribute('form-id'));
    const form = document.getElementById(this.getAttribute('form-id'));
    if (!picker || !form) return;
    // Explicit links and a customer's subsequent selection always take precedence.
    if (picker.hasAttribute('update-url') && new URL(location.href).searchParams.has('variant')) return;
    const blockSubmit = event => { event.preventDefault(); event.stopImmediatePropagation(); };
    form.addEventListener('submit', blockSubmit, true);
    const controls = [...picker.querySelectorAll('fieldset')];
    controls.forEach(control => { control.disabled = true; });
    try {
      await picker.selectCombination({ optionValues: this.getAttribute('option-values').split(','), productChange: false });
    } catch (error) {
      console.error('Could not select the pictured bundle colors', error);
    } finally {
      controls.forEach(control => { control.disabled = false; });
      form.removeEventListener('submit', blockSubmit, true);
    }
  }
}
if (!customElements.get('ft-bundle-default')) customElements.define('ft-bundle-default', FtBundleDefault);

document.addEventListener('click', async event => {
  const button = event.target.closest('[data-ft-bundle-preview]');
  if (!button) return;
  const gallery = button.closest('.shopify-section')?.querySelector('product-gallery') || document.querySelector('product-gallery');
  if (!gallery) return;
  event.preventDefault();
  await customElements.whenDefined('product-gallery');
  gallery.photoswipe.loadAndOpen(0, [{
    src: button.dataset.fullSrc,
    width: Number(button.dataset.imageWidth),
    height: Number(button.dataset.imageHeight),
    alt: button.querySelector('img').alt,
    msrc: button.querySelector('img').currentSrc,
    thumbnailElement: button.querySelector('img'),
    thumbCropped: false
  }]);
});
